import type { DocNode } from '@atlaskit/adf-schema';
import type { JSONNode } from '@atlaskit/editor-json-transformer';
import {
	SyncBlockStoreManager,
	type SyncBlockDataProvider,
	type SyncBlockInstance,
	type SyncBlockNode,
} from '@atlaskit/editor-synced-block-provider';
import type { NodeDataProvider } from '@atlaskit/node-data-provider';

import {
	SyncedBlockNodeComponentRenderer,
	type SyncedBlockNodeProps,
} from './ui/SyncedBlockNodeComponentRenderer';

const isSyncBlockDataProvider = (
	dataProvider: NodeDataProvider<SyncBlockNode, SyncBlockInstance>,
): dataProvider is SyncBlockDataProvider => {
	return dataProvider.name === 'syncBlockProvider';
};

// For rendering synced block nodes in Renderer
export const getSyncedBlockNodeComponent = (
	dataProvider: NodeDataProvider<SyncBlockNode, SyncBlockInstance>,
	doc: DocNode,
) => {
	const { content } = doc;
	const isEmpty = !content || !Array.isArray(content) || content.length === 0;
	const syncBlockNodes = isEmpty
		? []
		: content.filter((node: JSONNode) => node.type === 'syncBlock');

	const syncBlockStoreManager = isSyncBlockDataProvider(dataProvider)
		? new SyncBlockStoreManager(dataProvider as SyncBlockDataProvider)
		: undefined;

	if (!syncBlockStoreManager) {
		// TODO: EDITOR-2533 - returns a function that always renders error state
		throw new Error('Data provider is not a SyncBlockDataProvider');
	}

	// Pre-fetch sync block data
	syncBlockStoreManager
		.getReferenceSyncBlockStoreManager()
		.fetchSyncBlocksData(syncBlockNodes as SyncBlockNode[]);

	return (props: SyncedBlockNodeProps) =>
		SyncedBlockNodeComponentRenderer({ ...props, syncBlockStoreManager });
};
